module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Silver Aluminum + Concrete Open.956707ad.png";